import { stylesheet } from "typestyle";
export const layout = stylesheet({
    horizontal: {
        display: "flex",
        flexFlow: "row nowrap",
    },
    vertical: {
        display: "flex",
        flexFlow: "column nowrap",
    },
    horizontalWrap: {
        display: "flex",
        flexFlow: "row wrap",
    },
    fill: {
        flex: "1 1 auto",
    },
    fixed: {
        flex: "0 0 auto",
    },
    center: {
        justifyContent: "center",
    },
    start: {
        justifyContent: "flex-start",
    },
    end: {
        justifyContent: "flex-end",
    },
    alignStart: {
        alignItems: "flex-start",
    },
    alignCenter: {
        alignItems: "center",
    },
    alignEnd: {
        alignItems: "flex-end",
    },
    spaceEvenly: {
        justifyContent: "space-evenly",
    },
    spaceBetween: {
        justifyContent: "space-between",
    },
    spaceAround: {
        justifyContent: "space-around",
    },
    paddingSmall: {
        padding: "0.25rem 0.75rem"
    },
    paddingMedium: {
        padding: "0.75rem 1.5rem",
    },
    paddingLarge: {
        padding: "1.5rem 2.5rem"
    },
    marginSmall: {
        margin: "0.25rem 0.75rem"
    },
    marginMedium: {
        margin: "0.75rem 1.5rem",
    },
    marginLarge: {
        margin: "1.5rem 2.5rem"
    },
    marginYSmall: {
        marginTop: "0.25rem",
        marginBottom: "0.25rem",
    },
    marginYMedium: {
        marginTop: "0.75rem",
        marginBottom: "0.75rem",
    },
    marginYLarge: {
        marginTop: "1.5rem",
        marginBottom: "1.5rem",
    }
});
//# sourceMappingURL=layout.js.map